<template>
    <div style="margin: 0 auto" :style="$vuetify.breakpoint.mobile ? 'width: 100%; padding: 0 30px;' : 'width: 1024px'">

        <fieldset v-for="(data, data_key) in datas" :key="data_key" style="margin-bottom: 30px; padding: 0 10px; border-radius: 5px; border-width: 0; border: 2px solid #e4e4e4;">
            <legend style="padding: 0 6px; font-size: 14px; font-weight: bold;">{{ data.date }}</legend>
            <v-row>
                <v-col class="py-1 px-0" v-for="card in data.skill" :key="card.id" v-show="card.show" cols="6">
                    <div style="display: flex;">
                        <span style="min-width: 170px;">{{ card.name }}</span>
                        <span >: {{ card.value }}</span>
                    </div>
                </v-col>
            </v-row>
        </fieldset>
    
    </div>
</template>

<script>

    import OptionDataMixin from "../../../../mixins/optionDataMixin";
    import MainMixin from "../../../../mixins/mainMixin";
    import ValidatorMixin from "../../../../mixins/validatorMixin";

    export default {
        name: "membershipAbilityUsingPhoneInformation",
        mixins: [OptionDataMixin, MainMixin, ValidatorMixin],
        data() {
            return {};
        },
        computed: {
            datas(){
                return this.$store.state.membership.tab_items
            }
        },  
        methods: {},
        watch: {}
    };
</script>
